import { Injectable } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import * as moment from 'moment';
import { UserService } from '@app-services/user/user.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private apiUrl = ApiUrlConstant.apiUrl;

  private expTime: number = 30*60*1000 // 30 minutes in milisecond

  constructor(
    private userService: UserService
  ) { }

  profileImgError = (inputEvent: any) => {
    if(inputEvent) {
      inputEvent.target.src = "/assets/img/empty-profile.svg";
      // inputEvent.target.src = "/assets/img/user-placeholder.png";
      return true;
    } else {
      return true;
    }
  }

  removeQueryParam = (_url: any) => {
    return _url?.split("?").shift();
  }

  getFullMonthName = (_shortMoth: string = 'Jan') => {
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

    let _crntDate = new Date(current_time);
    let _newDate =  _shortMoth + ' 01, ' + _crntDate.getFullYear();
    return moment(new Date(_newDate)).startOf("month").format('MMMM');
  }

  getRoundingValue = (value: number = 0, step: number = 0.5) => {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.round(value * inv) / inv;
  }

  setDashboardSelectedTab = (_selectedTabQuery:any = {}, _expInMiliSec: number = this.expTime) => {
    if(Object.keys(_selectedTabQuery).length > 0) {
      const _userInfo = this.userService.getMobileAndName();
      let serverTime = localStorage.getItem('serverTime');
      let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");  
      const _expireTime = new Date(current_time).getTime() + _expInMiliSec;

      let _obj = {
        selectedTabQuery: _selectedTabQuery,
        userId: _userInfo.userId,
        expiryTime: _expireTime
      }
      localStorage.setItem('LCS_dashboardTabQuery', JSON.stringify(_obj));
    } else {
      localStorage.removeItem('LCS_dashboardTabQuery');
    }
  }

  getDashboardSelectedTab = () => {
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

    const crntDateObj = new Date(current_time);

    let _userInfo = this.userService.getMobileAndName();

    let _storageData = JSON.parse(localStorage.getItem('LCS_dashboardTabQuery'));
    console.group("getDashboardSelectedTab")
    console.log("_storageData: ", _storageData)
    console.log("_userInfo: ", _userInfo)
    console.log("expiryTime: ", _storageData?.expiryTime)
    console.log("crntTime: ", crntDateObj.getTime())
    console.groupEnd()
    if(_storageData && _storageData.userId == _userInfo.userId && crntDateObj.getTime() < _storageData.expiryTime) {
      return _storageData?.selectedTabQuery || null;
    } else {
      localStorage.removeItem('LCS_dashboardTabQuery')
      return null;
    }
  }

  removeDashboardSelectedTab = () => {
    localStorage.removeItem('LCS_dashboardTabQuery');
  }




}
